import { gql } from '@apollo/client'
import {
  BaseBlock,
  ButtonBlockFragment,
  ColumnLayoutBlockFragment,
  ContentCarouselBlockFragment,
  FaqsBlockFragment,
  FeaturedContentCarouselBlockFragment,
  HeadingBlockFragment,
  HtmlBlockFragment,
  ImageBlockFragment,
  JumpToLinksBlockFragment,
  ReferFriendBlockFragment,
  RichTextBlockFragment,
  ShareLinkBlockFragment,
  SpacerBlockFragment,
} from 'app/features/shared/blocks'
import { VideoBlockFragment } from 'app/features/shared/blocks/video-block'
import { usePersistedCacheQuery } from 'app/hooks'

export const staticContentPageQuery = gql`
  query StaticContentPages($slug: String!, $draft: Boolean!) {
    StaticContentPages(where: { slug: { equals: $slug } }, draft: $draft) {
      docs {
        title
        hideTitle
        slug
        featuredImage {
          url
          alt
        }
        isBasic
        content {
          ${ButtonBlockFragment.partialFragment}
          ${ColumnLayoutBlockFragment.partialFragment}
          ${ContentCarouselBlockFragment.partialFragment}
          ${FaqsBlockFragment.partialFragment}
          ${FeaturedContentCarouselBlockFragment.partialFragment}
          ${HeadingBlockFragment.partialFragment}
          ${HtmlBlockFragment.partialFragment}
          ${ImageBlockFragment.partialFragment}
          ${JumpToLinksBlockFragment.partialFragment}
          ${ReferFriendBlockFragment.partialFragment}
          ${RichTextBlockFragment.partialFragment}
          ${ShareLinkBlockFragment.partialFragment}
          ${SpacerBlockFragment.partialFragment}
          ${VideoBlockFragment.partialFragment}
        }
        updatedAt
      }
    }
  }
`
export interface StaticContentPagesQueryInput {
  slug: string
  draft: boolean
}

export interface StaticContentPagesQueryOutput {
  StaticContentPages: {
    docs: {
      title: string
      hideTitle: boolean
      slug: string
      featuredImage?: {
        url: string
        alt: string
      }
      isBasic: boolean
      content: BaseBlock[]
      updatedAt: string
    }[]
  }
}

export const useStaticContentPagesQuery = (input: StaticContentPagesQueryInput) =>
  usePersistedCacheQuery<StaticContentPagesQueryOutput, StaticContentPagesQueryInput>(staticContentPageQuery, {
    variables: input,
  })
